import React, { useState, useEffect } from 'react';
import Login from './Login';
import ChatApp from './ChatApp'; // Tu componente principal de chat
import {jwtDecode} from 'jwt-decode';

const App = () => {
  const [token, setToken] = useState(null);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Verificar si ya hay un token almacenado
    const storedToken = localStorage.getItem('authToken');
    if (storedToken) {
      const decoded = decodeToken(storedToken);
      if (decoded) {
        setToken(storedToken);
        // console.log("ESTE ES EL DECODED QUE SE ALMACENA PARA ENVIAR A LOS COMPONENTES: ", decoded);
        setUserData(decoded);
      }
    }
  }, []);

  const decodeToken = (token) => {
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Invalid token:', error);
      return null;
    }
  };

  const handleLogin = (newToken) => {
    const decoded = decodeToken(newToken);
    setToken(newToken);
    if (decoded) {
      setToken(newToken);
      setUserData(decoded);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setToken(null);
    setUserData(null);
  };

  return (
    <div>
      {token ? (
        <>
          <ChatApp token={token} userData={userData} />
          <button onClick={handleLogout} style={{ marginTop: '20px' }}>
            Logout
          </button>
        </>
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
};

export default App;
